<template>
  <div :class="['icon-attribute-item-fi', `icon-attribute-item-fi--size-${size}x`]">
    <icon-fi
      class="icon-attribute-item-fi__icon"
      :icon="icon"
      :size="`${size}`"
    />

    <div class="icon-attribute-item-fi__data">
      <span class="icon-attribute-item-fi__label">
        {{ label }}
      </span>
      <span class="icon-attribute-item-fi__value">
        {{ value }}
      </span>
    </div>
  </div>
</template>

<script>
import IconFi from 'atoms/icon-fi/IconFi';

export default {
  name: 'IconAttributeItemFi',
  components: {
    IconFi,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 2,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './icon-attribute-item-fi.scss';
</style>
